import React from "react";
import SearchSelect from "components/ui/SearchSelect";
import { useGetOrganizationsQuery } from "apis/organization";

// Shared org scope control for the admin lists. Clearing it means "all
// organizations", which is the only way to see users who belong to none.
const OrganizationFilter = ({
  value,
  onChange,
  label = "Organization",
  placeholder = "All organizations",
}) => {
  const { data: organizations = [] } = useGetOrganizationsQuery();

  const options = organizations.map((organization) => ({
    value: organization._id,
    label: organization.name,
  }));

  return (
    <div className="min-w-56">
      {label && (
        <label className="block text-sm mb-1 font-medium">{label}</label>
      )}
      <SearchSelect
        options={options}
        value={options.find((option) => option.value === value) || null}
        onChange={(option) => onChange(option?.value || "")}
        placeholder={placeholder}
        isClearable
      />
    </div>
  );
};

export default OrganizationFilter;
